import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import css from "./index.module.scss";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function Index({ prodList }) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (path) => {
    navigate(path);
  };

  return (
    <div className={css.containBox}>
      <div className={css.tabs}>
        {prodList.map((item, index) => (
          <div className={css.tab} key={index} onClick={() => goTo(item.path)}>
            <div className={css.imgbox}>
              <img src={item.pic} alt="" />
              {location.pathname === item.path && (
                <div className={css.name}>{t(item.name)}</div>
              )}
            </div>
            <div className={css.title}>{t(item.name)}</div>
          </div>
        ))}
      </div>
      <Outlet />
    </div>
  );
}

export default React.memo(Index);
